import service from '@/services/inventario/proveedor'

const proveedor = {
  nombre: '',
  nombreComercial: '',
  identificacion: { tipo: { id: '' }, numero: null },
  telefono: { codigoPais: 506, numTelefono: null },
  ubicacion: {
    provincia: { id: '' },
    canton: { id: '' },
    distrito: { id: '' },
    otrasSenas: ''
  },
  correoElectronico: '',
  codigoMoneda: { id: '' },
  cuentaContable: null,
  plazoCredito: null

  // tag: []
}

const getDefaultState = () => ({
  proveedor,
  proveedoresFEC: [],

  list: [],
  pageInfo: {},
  currentRow: null,

  saved: 'null',
  isListening: false
})

export const state = () => getDefaultState()

export const mutations = {
  RESET_STATE: state => Object.assign(state, getDefaultState()),
  SET_ROW: (state, row) => (state.currentRow = row),
  SET_ITEM: (state, obj) => {
    if (!obj.telefono)
      obj.telefono = {
        codigoPais: 506,
        numTelefono: 88888888
      }

    state.proveedor = obj

    state.saved = true
  },
  SET_ACCOUNT: (state, obj) => {
    state.proveedor.cuentaContable = obj
  },
  SET_PROVEEDORES_FEC: (state, objs) => {
    state.proveedoresFEC = objs
  },
  SET_LIST: (state, obj) => {
    state.list = [...new Set([...state.list.map(JSON.stringify), ...obj.feed.map(JSON.stringify)])].map(JSON.parse)

    state.pageInfo = obj.pageInfo
  },
  UPDATE_LIST: (state, obj) => {
    //TODO: mejorar la actualización, cuando se actualiza un elemento de la lista debe retornar sin volver al api
    const nObj = state.list.find(e => e._id === obj._id)
    if (!nObj) state.list = [obj, ...state.list]
    else Object.keys(nObj).forEach(i => (nObj[i] = obj[i]))

    state.saved = true
  },
  DELETE_LIST: (state, obj) => {
    state.list = state.list.filter(e => e._id !== obj._id)
  },
  RESET: (state, { monedaDef, identificacionDef }) => {
    state.proveedor = {
      ...getDefaultState().proveedor,
      nombre: '',
      correoElectronico: '',
      identificacion: { tipo: { id: identificacionDef }, numero: null },
      telefono: { codigoPais: 506, numTelefono: null },
      ubicacion: {
        provincia: { id: '' },
        canton: { id: '' },
        distrito: { id: '' }
      },
      codigoMoneda: { id: monedaDef.id }
    }
  },
  SAVE_CHANGES: (state, obj) => {
    state.proveedor = obj
    state.saved = false
  }
}

export const actions = {
  create: async ({ commit, rootGetters }, item) =>
    service
      .create({
        ...item,
        ...(item.plazoCredito && { plazoCredito: Number(item.plazoCredito) }),
        emisor: {
          _id: await rootGetters['facturacion/emisorStore/get_Id']
        }
      })
      .then(result => commit('UPDATE_LIST', { ...item, _id: result._id })),

  readById: async ({ state, commit }, { _id, refresh = false }) => {
    let item = state.list.find(e => e._id === _id)
    //TODO: mejorar la actualización, cuando se actualiza un elemento de la lista debe retornar sin volver al api
    if (refresh || !item || !item.correoElectronico) {
      item = await service.readById(_id)

      commit('UPDATE_LIST', item)
    }

    // TODO: Si no se usa, en la siguiente version v3.5 se borra
    // if (!item.identificacion) item = { ...item, identificacion }
    // if (!item.ubicacion) item = { ...item, ubicacion }
    // if (!item.telefono) item = { ...item, telefono: { codigoPais: 506, numTelefono: null } }
    // if (!item.codigoMoneda) item = { ...item, codigoMoneda: { id: '' } }

    commit('SET_ITEM', item)

    return item
  },

  findByIdentificacion: async ({ rootGetters }, item) =>
    service.findByIdentificacion({ ...item, emisor: { _id: await rootGetters['facturacion/emisorStore/get_Id'] } }),

  resetList: ({ state }) => {
    state.list = []
    state.pageInfo = {}
  },

  readAll: async ({ commit, state, dispatch }, { restart = false, limit = 10, filter = null }) => {
    if (restart) await dispatch('resetList')

    return service
      .readAll(rootGetters['facturacion/emisorStore/get_Id'], state.pageInfo.nextPageCursor, limit, filter)
      .then(result => commit('SET_LIST', result))
  },

  readAllByEmisor: async ({ commit, state, dispatch, rootGetters }, { restart = false, limit = 10, filter = null }) => {
    if (restart) await dispatch('resetList')

    return service
      .readAllByEmisor(rootGetters['facturacion/emisorStore/get_Id'], state.pageInfo.nextPageCursor, limit, filter)
      .then(result => commit('SET_LIST', result))
  },

  readByNombreIdentificacion: ({ commit }, nid) =>
    service.readByNombreIdentificacion(nid).then(result => {
      // si regresa solo 1 coincidencia, hace commit. si vienen +1, muestra al usuario las opciones.
      if (result.length === 1) {
        commit('SET_ITEM', result[0])
        return 1 // solo 1 opcion para seleccionar.
      }
      if (result.length > 1) {
        commit('SET_PROVEEDORES_FEC', result)
        return 'n' // hay n opciones para seleccionar
      }

      return 0 // no hay opciones.
    }),

  delete: ({ commit }, items) =>
    service.delete(items).then(result => {
      result.forEach(i => {
        if (i.state) commit('DELETE_LIST', i)
      })
      return result
    }),

  saveChanges: ({ commit }, item) => commit('SAVE_CHANGES', item),

  setCuentaContable: ({}, { _id, cuentaContable }) => service.setCuentaContable(_id, cuentaContable)
}
